"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WalletService = void 0;
const WalletServiceLive_1 = require("./WalletServiceLive");
class WalletService {
    static create() {
        return new WalletServiceLive_1.WalletServiceLive();
    }
}
exports.WalletService = WalletService;
//# sourceMappingURL=WalletService.js.map